
const persistHeader = require('./src/utils/persist-header').default


exports.wrapPageElement = persistHeader